/** 核心 mapper 函数，将前端配置项和后端数据结构合并为视图 VO */
export const getFrontListVo = (backendProductList, props, currentDynamicTagId) => {
    const { buyButtonText, headIcon, headIconImg, headIconText, headIconTextColor, headIconBackgroundColor, headIconBorderColor, scoreInfoSwitch, distanceInfoSwitch, salesInfoSwitch, bookInfoSwitch, priceColor, buyButtonTextColor, buyButtonBackgroundColor, destinationRetrySwitch } = props;
    const result = [];
    if (!(backendProductList && backendProductList?.length)) {
        return [];
    }
    backendProductList.forEach(backendProduct => {
        const { headImage, title, positionInfo, priceModel, status, rating, userReview, score, salesCount, extModel, bookInfo, positionMsg, productId, productIdStr, angleImg, privilegeTag, posTagList } = backendProduct;
        const positionInfoStr = positionInfo ? destinationRetrySwitch ? positionInfo.join('·') : positionInfo[0] : '';
        const poiListCard = {
            headImage: {
                value: headImage
            },
            title,
            positionInfo: positionInfoStr,
            price: priceModel,
            status,
            buyButtonText,
            salesCount,
            score,
            rating,
            userReview: userReview[0] ? `${userReview[0]}` : '',
            headIcon,
            headIconImg,
            headIconText,
            headIconTextColor,
            headIconBackgroundColor,
            headIconBorderColor,
            extModel,
            bookInfo,
            scoreInfoSwitch,
            distanceInfoSwitch,
            salesInfoSwitch,
            bookInfoSwitch,
            priceColor,
            buyButtonTextColor,
            buyButtonBackgroundColor,
            lat: positionMsg?.lat,
            lng: positionMsg?.lng,
            poiId: productId,
            productIdStr,
            angleImg,
            privilegeTag,
            posTagList
        };
        result.push(poiListCard);
    });
    return result;
};
